import { useMutation } from "react-query";
import { useContext } from "react";
import AuthContext from "../../contexts/AuthContext";

const { REACT_APP_API } = process.env;

const updateCustomer = async ({ authTokens, userPayload }) => {
  const response = await fetch(`${REACT_APP_API}/user`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authTokens.access_token}`,
    },
    body: JSON.stringify({
      ...userPayload,
      access_token: authTokens.access_token,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(
      error.error || error.message || "Failed to update customer"
    );
  }

  const result = await response.json();

  // Transform response to match expected format
  return { success: true, ...result };
};

export const useUpdateCustomer = (mutationOptions = {}) => {
  const { authTokens } = useContext(AuthContext);

  return useMutation({
    mutationKey: ["updateCustomer"],
    mutationFn: ({ userPayload }) => {
      // Use AuthContext tokens directly instead of localStorage to avoid stale tokens
      return updateCustomer({
        authTokens: { access_token: authTokens?.access_token },
        userPayload,
      });
    },
    ...mutationOptions,
  });
};
